import { message as $message } from 'antd'

import { loadMarketByDomain } from '@/services/sqmall/market'

const SqmallAndOpModel = {
    namespace: 'sqmallAndOp',
    state: {
        config: {},
        marketAddress: '',
        marketContactWay: '',
        marketCode: '',
    },
    effects: {
        *fetchConfig(_, { call, put }) {
            try {
                const marketDomain =
                    PROJECT_CONFIG.mode === 'dev' ? 'https://testssss.sursung.com' : window.location.origin
                const res = yield call(loadMarketByDomain, {
                    marketDomain,
                })
                const { success, data = {}, message } = res ?? {}

                if (success) {
                    const { mallTitle, opTitle } = data?.marketConfig?.info ?? {}
                    let newTitle = window.TERMINANAME_IS_SQMALL ? mallTitle : opTitle

                    if (newTitle) {
                        yield put({
                            type: 'settings/changeSetting',
                            payload: { title: newTitle },
                        })
                        document.title = newTitle
                    }

                    yield put({
                        type: 'update',
                        payload: {
                            config: data.marketConfig,
                            marketCode: data.marketCode,
                            marketAddress: data.marketAddress,
                            marketContactWay: data.marketContactWay,
                        },
                    })
                } else {
                    $message.error(message)
                }
            } catch (e) {
                console.error('catchError', e)
            }
        },
    },
    reducers: {
        update(state, { payload }) {
            return {
                ...state,
                ...payload,
            }
        },
    },
}

export default SqmallAndOpModel
